import { Component, OnInit, Injector, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { WorkOrdersService } from '../../work-orders.service';
import { GAWorkOrderService } from '../../../ve.service';
import { CgpConfirmationDialogService } from '../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { GaStudyTitlesDialogComponent } from '../dialogs/ga-study-titles-dialog/ga-study-titles-dialog.component';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

const VE_WORK_ORDER_ROUTE = '/VE/Work-Orders';

@Component({
  selector: 'ga-add-multiple',
  templateUrl: './ga-add-multiple.component.html',
  styleUrls: ['../../work-orders.component.scss']
})
export class GaAddMultipleComponent implements OnInit, OnDestroy {
  appCardTitle: string;
  router: Router;
  service: WorkOrdersService;
  gaWorkOrderService: GAWorkOrderService;
  cgpConfirmationDialogService: CgpConfirmationDialogService;
  cgpAlertDialogService: CgpAlertDialogService;
  isCancel = false;
  matDialog: MatDialog;
  studyTitles: any[];

  constructor(injector: Injector) {
    this.appCardTitle = 'Add Multiple New GA Work Orders';
    this.service = injector.get(WorkOrdersService);
    this.gaWorkOrderService = injector.get(GAWorkOrderService);
    this.cgpConfirmationDialogService = injector.get(CgpConfirmationDialogService);
    this.cgpAlertDialogService = injector.get(CgpAlertDialogService);
    this.router = injector.get(Router);
    this.matDialog = injector.get(MatDialog);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    this.service.resetForm();
    this.service.enableForm();
    this.service.resetGridView();
  }

  submit() {
    this.selectStudyTitles();
  }

  private selectStudyTitles() {
    const data = {
      title: 'Select Study Title(s) for Work Order Submission',
      yesLabel: 'Submit',
      noLabel: 'Cancel',
    };

    const dialogRef = this.matDialog.open(GaStudyTitlesDialogComponent, { data, width: '750px' });

    dialogRef.afterClosed()
      .subscribe(result => {
        this.studyTitles = result;
        if (this.studyTitles && this.studyTitles.length > 0) {
          this.createBulkWorkOrders();
        }
      });
  }

  private createBulkWorkOrders() {
    const gaWorkOrder = this.getGAWorkOrder();
    gaWorkOrder.StudyTitleIds = this.studyTitles;
    this.gaWorkOrderService.loading.next(true);

    this.gaWorkOrderService
      .save(gaWorkOrder, false, '/BulkCreate')
      .then(response => {
        this.gaWorkOrderService.loading.next(false);

        if (response) {
          this.cgpAlertDialogService.showAlertDialog({
            title: 'Confirmation',
            message: `${response.length} Work Orders created successfully.`,
            alert: 'success',
            closeLabel: 'OK',
          });
        } else {
          this.cgpAlertDialogService.showAlertDialog({
            title: 'Error',
            message: 'Work Orders not created. Please try again.',
            alert: 'danger',
            closeLabel: 'OK',
          });
        }
        this.router.navigate([this.service.workOrderGridRouting[this.service.getWorkOrderGridType()]()]);
      });
  }

  back = (isCancel) => {
    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: `Confirm ${isCancel ? 'Cancel' : 'Navigation'}`,
      message: `Are you sure you want to ${isCancel ? 'Cancel' : 'navigate away from this page'}? Your changes may be lost.`,
      alert: 'danger',
      onYesClick: () => {
        this.router.navigate([this.service.workOrderGridRouting[this.service.getWorkOrderGridType()]()]);
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });
  }

  /**
   * Build GA Work Order object to send in request
   * payload for Submit
   */
  getGAWorkOrder(): any {
    const workOrder = this.service.gaAddMultipleForm.value;
    workOrder.AddInfoCategories = workOrder.AddInfoCategories
      ? workOrder.AddInfoCategories
      : [];
    workOrder.ToolingOperatorInterfaces = workOrder.ToolingOperatorInterfaces
      ? workOrder.ToolingOperatorInterfaces
      : [];
    delete workOrder.ProgramDetailId;
    return workOrder;
  }

  public get isFormValid(): boolean {
    const isGaAddMultipleValid = this.service.gaAddMultipleForm.valid;
    const isAddInfoValid = Boolean(this.service.additionalInfoForm.value.Id) ?
    this.service.isAddInfoFormValid.getValue() && this.service.additionalInfoForm.valid :
    this.service.isAddInfoFormValid.getValue();
    const isDelObjValid = this.service.isDeliverablesObjFormValid;
    return isGaAddMultipleValid && isAddInfoValid && isDelObjValid;
  }

}
